import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthManagerService } from '../../api/auth/auth-manager.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SpatialAdjustManagerService } from '../../api/spatial-adjust/spatial-adjust-manager.service';

@Injectable({
    providedIn: 'root'
})
export class SpatialAdjustGuardService implements CanActivate {

    constructor(private authManager: AuthManagerService,
                private deviceDetector: DeviceDetectorService,
                private router: Router,
                private spatialAdjustManager: SpatialAdjustManagerService,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {

        if (environment.enableSpatialAdjust
            && this.spatialAdjustManager.isSpatialAdjustUser(this.authManager.dashAuthenticatedUser?.email)
            && (this.deviceDetector.isDesktop() || this.deviceDetector.isTablet())) {
            return true;
        }

        // TODO - Spatial Adjust Demo Support.
        if (environment.isDemoMode) {
            return true;
        }

        this.router.navigate(['/']);
    }
}
